import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

enum TestRunEntitySourceVariant {
  Production = 'Production',
  Test = 'Test',
}

export const StartBlockConfigSchema = z.object({
  isStartBlock: z.literal(true),
  entityType: z.string().optional(),
  // TODO: the testEntity doesn't really belong here. This is a property of a test run, not of a flow
  testEntityId: z.string().uuid().optional(),
  testPracticeId: z.string().uuid().optional(),
  testRunEntitySourceVariant: z.nativeEnum(TestRunEntitySourceVariant).optional(),
});
export type StartBlockConfig = z.infer<typeof StartBlockConfigSchema>;

export const StartBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Start),
  config: StartBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Start),
});
export type StartBlock = z.infer<typeof StartBlockSchema>;
